const lib = {
  formatMap: (data, keyName, valueName) => {
    const options = [];
    if (Object.prototype.toString.call(data) === '[object Object]') {
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          options.push({
            key,
            name: data[key],
          });
        }
      }
    } else {
      data.forEach((item) => {
        if (keyName) {
          options.push({
            key: item[keyName],
            name: item[valueName],
          });
        } else {
          options.push({
            key: item,
            name: item,
          });
        }
      });
    }
    return options;
  },
};

module.exports = lib;
